import { useEffect } from "react";
export function useAbort() {
    useEffect(function () {
        var abortController = new AbortController();
        return function () { return abortController.abort(); };
    }, []);
}
